import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from "vue";
import { polygonHull } from "d3-polygon";
import { curveCatmullRomClosed, line } from "d3-shape";


export default /*#__PURE__*/_defineComponent({
  __name: 'graph-strongly-connected-component',
  props: {
  greatest: {
    type: Boolean,
    default: false,
  },
  vertexCoordinates: {
    type: Array,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const { greatest, vertexCoordinates } = toRefs(props);

const hullLine = computed(() => {
  let hull = polygonHull(vertexCoordinates.value as [number, number][]);
  if (!hull) return null;

  let valueLine = line()
    .x(function (d) {
      return d[0];
    })
    .y(function (d) {
      return d[1];
    })
    .curve(curveCatmullRomClosed); //we want a smooth line

  let hullLine = valueLine(hull);
  if (hullLine) {
    return hullLine;
  }

  return null;
});

const classObject = computed(() => {
  return {
    scc: !greatest.value,
    greatest: greatest.value,
  };
});

return { __sfc: true,props, greatest, vertexCoordinates, hullLine, classObject }
}

})